import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import axios from "../../../axios/index";
import { useLocation } from "react-router-dom";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// Context
import { UserContext } from "../../Context/UserContextProvider";

import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css";

// Styles
import stylesMain from "../DashboardFileManagement/DashboardFileManagement.module.css";
import style from "./ArchiveRequests.module.css";
// import Mainstyles from "./SavedFiles.module.css"

// Re Useable Components
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";
import { toast } from "react-toastify";
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddToArchiveModal from "../DashboardFileManagement/CardDetail/AddToArchiveModal/AddToArchiveModal";
const JDate = require("jalali-date");

export default function ArchiveRequests(props) {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();
  const [showArchiveModel, setShowArchiveModel] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [selectedRequestId, setSelectedRequestId] = useState(0);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  let [editId, setEditId] = useState(0);
  let [editTitle, setEditTitle] = useState("");

  let [data, setData] = useState([]);
  let [showingData, setShowingData] = useState([]);
  let [showAccepted, setShowAccepted] = useState(false);

  const dataHandler = useCallback(async () => {
    axios
      .get("Archive/Requests", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setData(res.data.data);
        setIsLoading(false);
      });
  }, [userToken, state]);

  useEffect(() => {
    dataHandler();
  }, [dataHandler]);

  useEffect(() => {
    let cacheData = [];

    if (showAccepted) {
      data.forEach(d => {
        if (d.isAccepted) {
          cacheData.push(d);
        }
      });
    } else {
      data.forEach(d => {
        if (!d.isAccepted) {
          cacheData.push(d);
        }
      });
    }

    setShowingData(cacheData);
  }, [data, showAccepted]);

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  function acceptHandler(id) {
    notify("در حال قبول درخواست", "success");
    axios
      .put(
        "Archive/Request?reqId=" + id,
        {},
        {
          headers: {
            authorization: "Bearer " + userToken,
          },
        }
      )
      .catch(res => {
        notify("مشکلی در قبول پیش آمد", "error");
      })
      .then(res => {
        notify("درخواست قبول شد", "success");
        window.location.reload();
      });
  }

  function removeHandler(id) {
    notify("در حال حذف درخواست", "success");
    axios
      .delete("Archive/Request?reqId=" + id, {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .catch(res => {
        notify("مشکلی در حذف پیش آمد", "error");
      })
      .then(res => {
        window.location.reload();
      });
  }

  function startAccepting(estateId, description, title, id) {
    setSelectedId(estateId);
    setSelectedTitle(title);
    setSelectedRequestId(id);
    setSelectedDescription(description);
    setShowArchiveModel(true);
  }

  console.log(data);

  return (
    <>
      {isLoading ? (
        <div className={stylesMain.loader_container}>
          <div className={stylesMain.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-md-0 px-2 ${stylesMain.file_cards_container}`}>
                <DashboardHeader
                  setIsShowSidebar={setIsShowSidebar}
                  isShowSidebar={isShowSidebar}
                  onClick={() => setModalShow(true)}
                  class="px-3"
                  query={query}
                  setQuery={setQuery}
                  searchHandler={() => {}}
                />

                <AddToArchiveModal
                  acceptButtons={true}
                  fileName={selectedTitle || ""}
                  show={showArchiveModel}
                  id={selectedId}
                  userToken={userToken}
                  description={selectedDescription}
                  onHide={success => {
                    success === true ? acceptHandler(selectedRequestId) : success === false ? removeHandler(selectedRequestId) : console.log(success);
                    setSelectedId(0);
                    setEditTitle("");
                    setShowArchiveModel(false);
                  }}
                />

                <div className="py-2">
                  <div className="container-fluid">
                    <div
                      className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${
                        props.userAdd ? "" : "ms-md-5 ms-0 mt-3"
                      }`}
                      dir="rtl">
                      <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2 ">
                        <a href="#">
                          <img onClick={history.goBack} className="ms-2 pointer" src={arrowIcon} alt="icon" />
                        </a>
                        <div className={Dstyles.text1}>درخواست های آرشیو</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.selected_type}`}>
                  <div
                    className={`${style.selected_type_item} ${!showAccepted ? "" : style.selected_type_item_active}`}
                    onClick={() => {
                      setShowAccepted(true);
                    }}>
                    قبول شده
                  </div>
                  <div
                    className={`${style.selected_type_item} ${showAccepted ? "" : style.selected_type_item_active}`}
                    onClick={() => {
                      setShowAccepted(false);
                    }}>
                    در انتظار تایید
                  </div>
                </div>
                <div className={`${style.main_container}`}>
                  {showingData.length == 0 ? (
                    <div className={`${style.no_data}`}>
                      <p>داده ای وجود ندارد</p>
                    </div>
                  ) : (
                    <>
                      {showingData.map(d => {
                        let date = new Date(String(d.createdAt));
                        let jdate = new JDate(date);
                        let dateString =
                          jdate.getFullYear() +
                          "/" +
                          jdate.getMonth() +
                          "/" +
                          jdate.getDay() +
                          " . " +
                          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
                          ":" +
                          (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                          ":" +
                          (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
                        let title = d.archiveReason;
                        let des = d.archiveDescription;
                        let isAccepted = d.isAccepted;
                        let estateId = d.estateId;
                        let estateName = d.estateName;
                        let userName = d.userName;

                        return (
                          <div className={`${style.request}`}>
                            <div
                              className={`${style.request_title}`}
                              onClick={() => {
                                window.location.href = "/card-detail/" + estateId;
                              }}>
                              {estateName}
                            </div>
                            <div className={`${style.request_name}`}>
                              <div className={`${style.request_name_data}`}>{userName}</div>
                              <div className={`${style.request_name_title}`}>درخواست ارشیو از</div>
                            </div>
                            <div className={`${style.request_date}`}>
                              <div className={`${style.request_date_data}`}>{dateString}</div>
                              <div className={`${style.request_date_title}`}>تاریخ درخواست</div>
                            </div>
                            <div className={`${style.request_description}`}>
                              <div className={`${style.request_description_data}`}>{des.length > 25 ? des.slice(0, 25) + "..." : des}</div>
                              <div className={`${style.request_description_title}`}>توضیحات درخواست</div>
                            </div>
                            <div className={`${style.request_buttons}`}>
                              {isAccepted ? (
                                <div className={`${style.request_buttons_submit}`}>قبول شده</div>
                              ) : (
                                <div
                                  className={`${style.request_buttons_submit}`}
                                  onClick={() => startAccepting(d.estateId, d.archiveDescription, d.estateName, d.id)}>
                                  جزئیات
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              <DashboardSideMenu archiveRequests setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
